import t from "classnames";
import { createElement as p } from "react";
const g = ({ as: o, children: l, className: m, variant: s, weight: e, serif: c, ...d }) => {
  const f = s != null && s.startsWith("d") ? `display-${s == null ? void 0 : s.charAt(s.length - 1)}` : s;
  return p(
    o,
    {
      className: t(m, { [f]: !!s, serif: !!c }),
      style: e ? { fontWeight: e } : void 0,
      ...d
    },
    l
  );
};
export {
  g as default
};
